





















































import { useI18N } from '@a/composables/use-vue-i18n';
import { useConfigurationApi } from '@a/plugins/configuration';
import { useTracking } from '@a/plugins/tracking';
import { TrackingEventTypes } from '@a/plugins/tracking/types/tracking';
import { useStore } from '@a/store';
import { LandingPageItem, ProductExtension } from '@a/store/landingpage/types';
import { ProductServerLocation } from '@a/store/product/types';
import { defineComponent, ref } from '@vue/composition-api';
import { PropType } from 'vue';
import RegionSwitcherModal from '../footer/RegionSwitcherModal.vue';

export default defineComponent({
  components: {
    RegionSwitcherModal,
  },
  name: 'OrderNowButton',
  props: {
    units: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    extras: {
      type: Array as PropType<Array<ProductExtension>>,
      required: false,
      default: () => [],
    },
    currentLocation: {
      type: Object as PropType<ProductServerLocation>,
      required: true,
    },
    buttonClasses: {
      type: [String, Array] as PropType<string | Array<string>>,
      required: false,
      default: () => [],
    },
  },
  setup(props) {
    const tracking = useTracking();
    const { data } = useConfigurationApi();
    const landingpageData = (data.pageData != null) ? data.pageData as LandingPageItem : null;

    const showRegionModal = ref<boolean>(false);
    const i18n = useI18N();
    const store = useStore();
    const orderWidgetFormRef = ref<HTMLFormElement>(null);

    const INPUT_EXTENSION_FIELD = 'data[Order][extras]';

    /**
     * this will return the key for the hidden input
     * which will be used by the OS1 to create a basket
     * e.x.: Order.extra[Modspace]
     */
    const getInputExtensionField = (extra: ProductExtension) : string => `${INPUT_EXTENSION_FIELD}[${extra.key}]`;

    const onWidgetSubmit = () => {
      showRegionModal.value = props.currentLocation.switchRegion && store.getters['auth/customer'] !== null;

      tracking.track({
        event: TrackingEventTypes.LP_SLOTBOX_SB_LOCATION,
        data: {
          type: 'button',
          target: props.currentLocation.orderUrl ?? undefined,
          productKey: landingpageData != null ? landingpageData.key : null,
          configuration: {
            units: props.units,
            duration: props.duration,
          },
        },
      });

      if (!showRegionModal.value) {
        orderWidgetFormRef.value.submit();
      }
    };

    const onRegionSwitcherConfirm = () => {
      showRegionModal.value = false;
      orderWidgetFormRef.value.submit();
    };

    return {
      i18n,
      showRegionModal,
      orderWidgetFormRef,
      getInputExtensionField,
      onWidgetSubmit,
      onRegionSwitcherConfirm,
    };
  },
});
